import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LOGIN_PAGE_PATH } from 'utils/consts/path'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-sw-60);
  font: var(--typography-14-16-semibold);
  padding-top: 16px;
`
const Title = styled.span`
  cursor: pointer;
`

const Login = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()

  const redirect = () => {
    navigate(LOGIN_PAGE_PATH)
  }

  return (
    <Wrapper>
      <Title
        onClick={redirect}
        data-testid='forgot-password-back-to-login-link'
      >
        {t('forgotPwd.back')}
      </Title>
    </Wrapper>
  )
}

export default Login
